import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "It Only Gets Better",
  date: new Date(2024, 9, 6),
  img: "/img/wormhole.jpeg",
  video: "/videos/wormhole.mp4",
  tracks: [
    {
      title: "A Jolly Beginning",
      src: "/songs/2024-10-06/a_jolly_beginning.mp3",
      duration: 481.8,
    },
    {
      title: "Squaring The Circle",
      src: "/songs/2024-10-06/squaring_the_circle.mp3",
      duration: 655.128,
    },
    {
      title: "The Sweetness of Candied Silence",
      src: "/songs/2024-10-06/the_sweetness_of_candied_silence.mp3",
      duration: 563.304,
    },
    {
      title: "Counting Down The Seconds ('til you return)",
      src: "/songs/2024-10-06/counting_down_the_seconds.mp3",
      duration: 489.744,
    },
    {
      title: "From Funk to Folk",
      src: "/songs/2024-10-06/from_funk_to_folk.mp3",
      duration: 845.088,
    },
    {
      title: "Into The Wormhole",
      src: "/songs/2024-10-06/into_the_wormhole.mp3",
      duration: 565.2,
    },
    {
      title: "Short Song Syndrome",
      src: "/songs/2024-10-06/short_song_syndrome.mp3",
      duration: 410.712,
    },
    {
      title: "The Struggle is Real (but the Kicks are Free)",
      src: "/songs/2024-10-06/the_struggle_is_real.mp3",
      duration: 1479.84,
    },
    {
      title: "Manic Pixie Dream Girl",
      src: "/songs/2024-10-06/manic_pixie_dream_girl.mp3",
      duration: 1622.376,
    },
    {
      title: "Hidden In The Bushes",
      src: "/songs/2024-10-06/hidden_in_the_bushes.mp3",
      duration: 657.432,
    },
    {
      title: "It's a Jolly Holiday (with you Burt)",
      src: "/songs/2024-10-06/a_jolly_holiday.mp3",
      duration: 1192.464,
    },
  ],
};
export default album;
